import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var getVideoDimensionsFromBlob = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blob) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            var url = URL.createObjectURL(blob);
            var video = document.createElement('video');
            video.preload = 'metadata';
            video.src = url;
            video.muted = true;

            // loadedmetadata, loadeddata, play, playing
            video.addEventListener('loadedmetadata', function timeupdateHandler() {
              video.removeEventListener('loadedmetadata', timeupdateHandler);
              resolve({
                width: video.videoWidth,
                height: video.videoHeight
              });
              URL.revokeObjectURL(url);
            });
            video.addEventListener('error', function () {
              reject(new Error('failed to load video'));
              URL.revokeObjectURL(url);
            });
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getVideoDimensionsFromBlob(_x) {
    return _ref.apply(this, arguments);
  };
}();